<template>
  <div class="columns is-mobile is-gapless is-marginless">
    <div class="column is-narrow" v-if="hasChildren">
      <span class="icon" @click="toggle">
        <img
          class="tree-icon"
          v-if="isOpen"
          src="../../../assets/svg/chevron-down.svg"
        />
        <img
          class="tree-icon"
          v-else
          src="../../../assets/svg/chevron-left.svg"
        />
      </span>
    </div>
    <div class="column">
      <component
        :is="catalogType"
        :catalog="catalog"
        :class="{ 'has-text-weight-semibold': isHighlighted }"
        @click="toggle"
        @catalog-checked="catalogCheckedHandler"
        @catalog-partchecked="catalogPartCheckedHandler"
        :is-checked="isCheked"
      ></component>
      <ul v-show="isOpen" v-if="hasChildren">
        <li v-for="child in catalog.children" :key="child.id" class="tree-list">
          <catalog
            :catalog="child"
            @catalog-checked="catalogCheckedHandler"
            @catalog-partchecked="catalogPartCheckedHandler"
          ></catalog>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import CatalogFolder from "./CatalogFolder";
import CatalogMap from "./CatalogMap";
import CatalogLayer from "./CatalogLayer";

export default {
  name: "catalog",
  props: {
    catalog: Object,
  },
  components: {
    CatalogFolder,
    CatalogMap,
    CatalogLayer,
  },
  computed: {
    catalogType() {
      return `Catalog${this.catalog.type}`;
    },
    hasChildren() {
      return this.catalog.children && this.catalog.children.length > 0;
    },
    isHighlighted() {
      return (
        this.numberCheckedChildren > 0 || this.numberPartCheckedChildren > 0
      );
    },
    isCheked() {
      return (
        this.hasChildren &&
        this.numberCheckedChildren == this.catalog.children.length
      );
    },
  },
  data() {
    return {
      isOpen: this.catalog.isOpen,
      numberCheckedChildren: 0,
      numberPartCheckedChildren: 0,
    };
  },
  methods: {
    toggle: function() {
      this.isOpen = !this.isOpen;
    },
    catalogCheckedHandler(value) {
      const isChekedOld = this.isCheked;
      this.numberCheckedChildren += value;
      if (isChekedOld !== this.isCheked || !this.hasChildren)
        this.$emit("catalog-checked", this.numberCheckedChildren ? 1 : -1);
    },
    catalogPartCheckedHandler(value) {
      const numberPartCheckedChildrenOld = this.numberPartCheckedChildren;
      this.numberPartCheckedChildren += value;
      if (
        (numberPartCheckedChildrenOld > 0 &&
          this.numberPartCheckedChildren <= 0) ||
        (numberPartCheckedChildrenOld <= 0 &&
          this.numberPartCheckedChildren > 0)
      )
        this.$emit(
          "catalog-partchecked",
          this.numberPartCheckedChildren ? 1 : -1
        );
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.tree-list {
  margin: 6px 0 0 0;
  cursor: pointer;
}

.tree-icon {
  margin-right: 9px;
}

.tree-node {
  margin: 0 0 0 24px;
}
</style>
